(() => {
  const KLAVIYO_COMPANY_ID = "TmAwti";
  const KLAVIYO_API_REVISION = "2023-08-15";
  const SALE_EVENT = "black_friday_sale_26";

  /**
   * Black Friday 2026 | Voranmeldung lists.
   * Channels without a dedicated list (wa, sms, bm, ff, sale) still set
   * sale_channel correctly and fall back to the onlineshop list.
   */
  const LIST_BY_CHANNEL = {
    tt: "Vammc8",
    google: "S5SnhS",
    meta: "TjjduL",
    mail: "WuMsKj",
    fitx: "YA5mvL",
    onlineshop: "Uw9NuM",
  };

  const getListIdForChannel = (channel) => {
    const canonical =
      window.SmilodoxSaleChannel?.toCanonical(channel) || "onlineshop";
    return LIST_BY_CHANNEL[canonical] || LIST_BY_CHANNEL.onlineshop;
  };

  const getSaleChannel = () =>
    window.SmilodoxSaleChannel?.get() ||
    window.SmilodoxSaleChannel?.FALLBACK_CHANNEL ||
    "onlineshop";

  const subscribeToSaleList = async ({
    email,
    name,
    customSource = "Shopify Sale Signup",
  }) => {
    const normalizedEmail = (email || "").trim().toLowerCase();
    const saleChannel = getSaleChannel();
    const listId = getListIdForChannel(saleChannel);

    const profileAttributes = {
      email: normalizedEmail,
      properties: {
        sale_channel: saleChannel,
        sale_event: SALE_EVENT,
      },
    };

    if (name) {
      profileAttributes.first_name = name;
    }

    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`,
      {
        method: "POST",
        headers: {
          revision: KLAVIYO_API_REVISION,
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: customSource,
              profile: {
                data: {
                  type: "profile",
                  attributes: profileAttributes,
                },
              },
            },
            relationships: {
              list: {
                data: { type: "list", id: listId },
              },
            },
          },
        }),
      }
    );

    if (!response.ok) {
      let body = "";
      try {
        body = (await response.text()).slice(0, 500);
      } catch (_) {
        body = "";
      }
      const error = new Error("Klaviyo subscription failed");
      error.status = response.status;
      error.body = body;
      throw error;
    }

    return { listId, saleChannel, saleEvent: SALE_EVENT };
  };

  window.SmilodoxSaleSignup = {
    KLAVIYO_COMPANY_ID,
    KLAVIYO_API_REVISION,
    SALE_EVENT,
    LIST_BY_CHANNEL,
    getSaleChannel,
    getListIdForChannel,
    subscribeToSaleList,
  };
})();
